import { DateTime } from 'luxon';

import { StatsTicketing } from '@apps/its2/domain/models';

export class Ticketing
{
    public validUntil?: DateTime;
    public stats: StatsTicketing;

    constructor ()
    {
        this.validUntil = null;
    }
}
